<template>
  <svg width="20"
       height="16"
       viewBox="0 0 20 16"
       :fill="color"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 16V7H13V0H20L18 5H20L15 16ZM13 9V16H2C0.9 16 0 15.1 0 14V11C0 9.9 0.9 9 2 9H13ZM4.25 11.75H2.75V13.25H4.25V11.75ZM11 0V7H2C0.9 7 0 6.1 0 5V2C0 0.9 0.9 0 2 0H11ZM4.25 2.75H2.75V4.25H4.25V2.75Z"
      fill="#2DA7D7" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
